import * as React from 'react';

import { IconProps } from './types';

export const ArrowUpIcon = React.forwardRef<SVGSVGElement, IconProps>((props, forwardedRef) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={forwardedRef}
    {...props}
  >
    <path
      d="M7.5 3L11 6.5H9V12H6V6.5H4L7.5 3Z"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    ></path>
  </svg>
));
ArrowUpIcon.displayName = 'ArrowUpIcon';

export default ArrowUpIcon;
